import * as React from 'react';
import {Linking, Text, TouchableOpacity, View} from 'react-native';
import {useSelector} from 'react-redux';
import {images} from '../../../../assets/icons';
import {contentSelector} from '../../../../redux/selectors/resources';
import {useStyles} from '../../../hooks/styles';
import {formatPhone, formatPhoneToCallable, openExternalPhone} from '../../../pipes';
import {useTheme} from '../../../theme';
import {useCallback, useMemo} from 'react';

export const CardInfoCardBlocked: React.FC = () => {
  const content = useSelector(contentSelector());
  const theme = useTheme();
  const styles = useStyles(() => ({
    container: {
      flex: 1,
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      paddingVertical: 10,
      paddingHorizontal: 20,
    },
    message: {
      ...theme.fonts.body,
      color: theme.color.white,
    },
    phoneLink: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    phoneNumber: {
      ...theme.fonts.action,
      color: theme.color.white,
      marginLeft: 10,
    },
  }));

  const formattedPhone = useMemo(
    () => formatPhone(content.eskmoContacts.supportPhone),
    [content.eskmoContacts.supportPhone],
  );

  const handleClickCall = useCallback(() => {
    const phone = formatPhoneToCallable(content.eskmoContacts.supportPhone);
    openExternalPhone(phone);
  }, [content.eskmoContacts.supportPhone]);

  return (
    <View style={styles.container} testID='blocked-card'>
      <Text style={styles.message} testID='blocked-card--message'>
        {content.cardBlocking.unblockMessage}
      </Text>
      <TouchableOpacity testID='card-info-phone' style={styles.phoneLink} onPress={handleClickCall}>
        <images.Phone color={theme.color.white} />
        <Text style={styles.phoneNumber}>{formattedPhone}</Text>
      </TouchableOpacity>
    </View>
  );
};
